import React from 'react'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { useTranslation } from 'react-i18next'
import { useDispatch, connect } from 'react-redux'
import ModalActions from 'reducers/Modal'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { thunks as PlayQueueThunks } from 'reducers/PlayQueue'
import { trackEvent } from 'utils/segmentService'
import { StyledModal } from '../Modals.styles'
import {
  ActionButton,
  Actions,
  BodyText,
  CloseButton,
  CloseRow,
  CopyBlock,
  ModalContent,
  Title
} from './ClearQueueModal.styles'

const mapStateToProps = ({ modal }) => ({
  showClearQueueModal: modal?.showClearQueueModal
})

function ClearQueueModal({ showClearQueueModal }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()

  const onCancelClick = () => {
    dispatch(ModalActions.toggleClearQueueModal())
  }

  const onConfirmClick = () => {
    dispatch(PlayQueueThunks.clearQueue())
    dispatch(ModalActions.toggleClearQueueModal())
  }

  return (
    <StyledModal
      $isMobile={isMobile}
      isOpen={showClearQueueModal}
      onClose={onCancelClick}
      analyticsModalType="clear_queue"
      trackEvent={trackEvent}
      containerStyles={{
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: '24px 12px',
        width: isMobile ? 'min(288px, calc(100vw - 32px))' : '288px'
      }}
      bodyStyles={{
        width: '100%'
      }}
    >
      <ModalContent>
        <CopyBlock>
          <CloseRow>
            <CloseButton
              type="button"
              aria-label={t('general.cancel')}
              onClick={onCancelClick}
            >
              <MaterialIcon name="X" color="currentColor" />
            </CloseButton>
          </CloseRow>

          <Title>{t('sidebar.clear-queue-disclaimer')}</Title>

          <BodyText>{t('sidebar.clear-queue-body')}</BodyText>
        </CopyBlock>

        <Actions>
          <ActionButton
            variant="primary"
            setting="player"
            mode="dark"
            onClick={onConfirmClick}
          >
            {t('general.clear-queue')}
          </ActionButton>

          <ActionButton
            variant="secondary"
            setting="player"
            mode="dark"
            onClick={onCancelClick}
          >
            {t('general.cancel')}
          </ActionButton>
        </Actions>
      </ModalContent>
    </StyledModal>
  )
}

export default connect(mapStateToProps)(ClearQueueModal)
